import request from '../../axios';
import {IOrderResponse} from './types';

export const getStoreOrderDetails = async ({
  orderGuid,
}: {
  orderGuid?: string;
}) => {
  const {data}: {data: IOrderResponse} = await request.get(
    `/api/v2/order/store-order/detail/${orderGuid}`,
  );

  return data;
};
